import React from 'react';
import Styles from './Popup.module.css'

function Popup(props) {
  return (props.trigger)? (
    <div className={Styles.popup}>
      <div className={Styles.popup_inner}>
        <button className={Styles.close_btn} onClick={() => props.setTrigger(false)}>close</button>
{props.children}
      </div>

    </div>
  ) :"";
}

export default Popup
